import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const unarchiveContact = async (uuid: string) => {
  const response = await CustomAxios.post(`contacts/${uuid}/unarchive`);
  return response.data;
};

interface UseUnarchiveContactProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useUnarchiveContact({ uuid, onSuccessCallback }: UseUnarchiveContactProps) {
  return useMutation({
    mutationFn: () => unarchiveContact(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allContacts, uuid] });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to unarchive the contact. Please try again and contact support if the problem persists.');
      }
    },
  });
}
